
  document.addEventListener('click', function(event) {
    document.querySelectorAll('.std-fridge-dropdown[open]').forEach(function(menu) {
      if (!menu.contains(event.target)) menu.open = false;
    });
  }, true);
  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.std-fridge-dropdown[open]').forEach(function(menu) {
      menu.open = false;
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    });
  });
